import styles from './PageHeader.module.scss'
import cn from 'classnames'
import { useRouter } from 'next/router'
import Button from '@/components/Button'
import AuthService from '@/services/AuthService'
import renderCustomIcon from '@/utils/renderCustomIcon'

function PageHeader({ data = {}, isProfilePage = false, className, ...props }) {
  const router = useRouter()
  if (Object.keys(data).length === 0) return null
  if (data.name === null || data.icon === null) return null

  const Icon = renderCustomIcon(data.icon)

  async function logout() {
    try {
      const response = await AuthService().logout()
      if (!response.ok) throw response.statusText

      router.push('/inloggen')
    } catch (error) {
      throw new Error(error)
    }
  }

  return (
    <div
      className={cn('breadcrumbs-bar', styles['root'], { [className]: className })}
      {...props}
    >
      <div>
        <Icon />

        <p>{data.name}</p>
      </div>

      {isProfilePage && (
        <Button
          onClick={logout}
          outline
          color="white-gray"
        >
          Uitloggen
        </Button>
      )}
    </div>
  )
}

export default PageHeader
